export * from './about-hiv-tool.component';
